import "core-js/modules/es.object.keys.js";
export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      //通知是否显示
      topNoticeShow: true,
      defaultLangId: 0
    };
  },
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  mounted: function mounted() {
    this.loadNoticeShow();
  },
  methods: {
    //显示通知逻辑
    loadNoticeShow: function loadNoticeShow() {
      // let date = Date.parse( new Date(uni.getStorageSync('noticeInfo').lastUpdateTime) )
      // ////console.log(date)
      // let now = Date.parse( new Date('2021-10-10 11:12:03') )
      // ////console.log(now)
    },
    //关闭通知逻辑
    closeNotice: function closeNotice() {
      // this.topNoticeShow = false;
    },
    //跳转外联
    jumpTo: function jumpTo() {
      // if(uni.getStorageSync('noticeInfo').linkUrl){
      //   window.location.href = uni.getStorageSync('noticeInfo').linkUrl
      // }
    }
  }
};